function Homepage(el) {
    this.el = el;
    this.sectionEls = this.el.querySelectorAll('.jsHomeSection');
    this.activeSectionSlug = 'home';
    this.lastScrollPos = 0;

    this.parallaxStartWidth = 750;

    this.initSectionHome();
    this.initSectionDrop();
    this.initSectionBdg();
    this.initSectionDeklaag();
    this.initSectionPrehistory();
    this.initSectionGrondwater();
    this.initSectionGlas();
    this.initScrollProgressIndicator();

    // Map the section sounds
    this.sectionSoundMap = {
        home: homeSoundUrl,
        drop: dropSoundUrl,
        bdg: bdgSoundUrl,
        deklaag: deklaagSoundUrl,
        prehistory: prehistorySoundUrl,
        grondwater: grondwaterSoundUrl,
        glas: glasSoundUrl
    };

    // Create the section map
    this.sectionMap = [];
    this.sectionEls.forEach(el => {
        const bounds = el.getBoundingClientRect();

        this.sectionMap.push({
            start: bounds.top,
            end: bounds.top + bounds.height,
            section: el.dataset.sectionSlug
        });
    });

    // Init the sound button
    const soundBtnEl = this.el.querySelector('.jsSoundToggleBtn');
    soundBtnEl.addEventListener('click', e => {
        e.preventDefault();

        globalSoundIsOn = !globalSoundIsOn;

        if (globalSoundIsOn) {
            globalAudioPlayer.play();
            soundBtnEl.classList.remove('sound-off');
            soundBtnEl.classList.add('sound-on');
            soundBtnEl.ariaLabel = 'Zet het geluid uit';
        }
        else {
            globalAudioPlayer.pause();
            soundBtnEl.classList.add('sound-off');
            soundBtnEl.classList.remove('sound-on');
            soundBtnEl.ariaLabel = 'Zet het geluid aan';
        }
    });

    window.addEventListener('scroll', _ => this.changeAudioOnScroll());
}

Homepage.prototype.initScrollProgressIndicator = function() {
    this.scrollIndicatorEl = this.el.querySelector('.jsProgressIndicator');
    this.scrollIndicatorProgressEl = this.el.querySelector('.jsProgressIndicatorProgress');
    
    this.setScrollProgressIndicator();
    window.addEventListener('scroll', _ => this.setScrollProgressIndicator());
};

Homepage.prototype.setScrollProgressIndicator = function() {
    const percentage = window.scrollY / (document.body.offsetHeight - window.innerHeight) * 100;
    
    gsap.to(this.scrollIndicatorProgressEl, { width: percentage + '%', duration: 0.2, ease: Power2.easeOut });
};

Homepage.prototype.changeAudioOnScroll = function() {
    if (!globalSoundIsOn) return;

    const scrollDown = this.lastScrollPos < window.scrollY;
    const marker = window.scrollY + (window.innerHeight / 2);

    if (scrollDown) {
        let sectionSlugToActivate = null;

        this.sectionMap.forEach(item => {
            if (marker >= item.start && marker < item.end) sectionSlugToActivate = item.section;
        });
    
        if (sectionSlugToActivate && sectionSlugToActivate !== this.activeSectionSlug) {
            this.activeSectionSlug = sectionSlugToActivate;
            this.activateAudioForSection(sectionSlugToActivate);
        }
    }
    else {
        for (let i = 0; i < this.sectionMap.length; i++) {
            const item = this.sectionMap[i];

            if (marker >= item.start && marker < item.end) {
                if (item.section !== this.activeSectionSlug) {
                    this.activeSectionSlug = item.section;
                    this.activateAudioForSection(item.section);
                }

                break;
            }
        }
    }

    this.lastScrollPos = window.scrollY >= 0 ? window.scrollY : 0;
};

Homepage.prototype.activateAudioForSection = function(sectionSlug) {
    if (!globalSoundIsOn || globalAudioPlayer.src === this.sectionSoundMap[sectionSlug]) return;

    gsap.timeline()
        .to(globalAudioPlayer, 0.5, { volume: 0 })
        .add(_ => {
            globalAudioPlayer.src = this.sectionSoundMap[sectionSlug];
            globalAudioPlayer.play();
        })
        .to(globalAudioPlayer, 0.5, { volume: 1 })
    ;
};

Homepage.prototype.initSectionHome = function() {
    const downBtnEl = this.el.querySelector('.jsHomeOverlay .jsDownBtn');
    const logoEl = this.el.querySelector('.jsLogo');
    const bottomTextEl = this.el.querySelector('.jsBottomText');

    gsap.timeline()
        .to(1, { opacity: 1, ease: Power2.easeInOut })
        .to([logoEl, bottomTextEl, downBtnEl], 1.5, { y: 0, opacity: 1, ease: Power2.easeInOut, stagger: 0.3 }, '-=0.5')
    ;

    // Init the down button
    downBtnEl.addEventListener('click', e => {
        e.preventDefault();
        vanillaSmoothie.scrollTo((window.innerHeight), { duration: 2000, easing: 'easeInOutQuad' });
    });
};

Homepage.prototype.initSectionDrop = function() {
    const dropSectionEl = this.el.querySelector('.jsSectionDrop');
    const dropOverlayEl = this.el.querySelector('.jsDropOverlay');

    const dropEl = this.el.querySelector('.jsDrop');
    const clouds1El = this.el.querySelector('.jsClouds');
    const clouds2El = this.el.querySelector('.jsClouds2');
    const buttons = dropOverlayEl.querySelectorAll('.button');

    // Cloud timeline
    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: dropSectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + dropSectionEl.offsetHeight * 2
            }
        });
    
        timeline.to([clouds1El, clouds2El], 1, { y: -(window.innerWidth * 0.18), scale: 1.05, ease: Power0.easeNone });
    
    
        // Drop timeline
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: dropSectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + (dropSectionEl.offsetHeight * 1.5)
            }
        });
    
        timeline2.to(dropEl, 1, { y: dropSectionEl.offsetHeight * 0.75, rotate: 45, scale: 0, ease: Power2.easeInOut });
        timeline2.to(dropEl, 0.5, { opacity: 0, ease: Power2.easeInOut }, '-=0.5');
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsDropOverlay .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionBdg = function() {
    const sectionEl = this.el.querySelector('.jsSectionBdg');
    const layer1El = sectionEl.querySelector('.layer1');
    const layer2El = sectionEl.querySelector('.layer2');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.20), ease: Power0.easeNone });
    
    
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline2.to(layer2El, 1, { y: -(window.innerWidth * 0.1), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionBdg .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionDeklaag = function() {
    const sectionEl = this.el.querySelector('.jsSectionDeklaag');
    const layer1El = sectionEl.querySelector('.layer1');
    const layer2El = sectionEl.querySelector('.layer2');
    const layer3El = sectionEl.querySelector('.layer3');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.15), ease: Power0.easeNone });
    
    
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline2.to(layer2El, 1, { y: -(window.innerWidth * 0.1), ease: Power0.easeNone });
    
    
        // Layer 3 animation
        const timeline3 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight
            }
        });
    
        timeline3.to(sectionEl, 1, { y: -(window.innerWidth * 0.12), ease: Power2.easeOut });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionDeklaag .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionPrehistory = function() {
    const sectionEl = this.el.querySelector('.jsSectionPrehistory');
    const layer1El = sectionEl.querySelector('.layer1');
    const buttons = sectionEl.querySelectorAll('.button');


    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionPrehistory .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionGrondwater = function() {
    const sectionEl = this.el.querySelector('.jsSectionGrondwater');
    const layer1El = sectionEl.querySelector('.layer1');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionGrondwater .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionGlas = function() {
    const sectionEl = this.el.querySelector('.jsSectionGlas');
    const layer1El = sectionEl.querySelector('.layer1');
    const layer3El = sectionEl.querySelector('.layer3');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });


        // Ceiling animation
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });

        timeline2.to(layer3El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionGlas .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};


Homepage.prototype.setElementAspectRatio = function(el, ratio, minHeight) {
    el.style.width = '';
    el.style.height = '';

    let newWidth = window.innerWidth;
    let newHeight = (el.offsetWidth / ratio[0]) * ratio[1];

    if (newHeight < minHeight) {
        newHeight = minHeight;
        newWidth = (newHeight / ratio[1]) * ratio[0];
    }

    el.style.width = newWidth + 'px';
    el.style.height = newHeight + 'px';
};

(function() {
    const homeEl = document.querySelector('.jsHome');
    if (homeEl) new Homepage(homeEl);
})();